function initiateDiagnosticStep(diagnostic) {
  // const { description, signSymptom } = evolution;

  return diagnostic || null;
}

export { initiateDiagnosticStep };
